export function configureCharts(Highcharts) {
    /* display negative numbers on logarithmic chartss*/
    (function (H) {
        H.addEvent(H.Axis, 'afterInit', function () {
            const logarithmic = this.logarithmic;

            if (logarithmic && this.options.custom.allowNegativeLog) {

                // Avoid errors on negative numbers on a log axis
                this.positiveValuesOnly = false;

                // Override the converter functions
                logarithmic.log2lin = num => {
                    const isNegative = num < 0;

                    let adjustedNum = Math.abs(num);

                    if (adjustedNum < 10) {
                        adjustedNum += (10 - adjustedNum) / 10;
                    }

                    const result = Math.log(adjustedNum) / Math.LN10;
                    return isNegative ? -result : result;
                };

                logarithmic.lin2log = num => {
                    const isNegative = num < 0;

                    let result = Math.pow(10, Math.abs(num));
                    if (result < 10) {
                        result = (10 * (result - 1)) / (10 - 1);
                    }
                    return isNegative ? -result : result;
                };
            }
        });

        // Remove legend items that are not shown
        Highcharts.addEvent(Highcharts.Legend, 'afterGetAllItems', ({
            allItems
        }) => {
            let i = allItems.length;
            while (i--) {
                if (allItems[i].options.showInLegend === false) {
                    allItems.splice(i, 1);
                }
            }
        });
    }(Highcharts));

    // Bind pie legend hover to show corresponding point tooltip globally
    function bindPieLegendHover(chart) {
        if (!chart || !chart.legend || !chart.legend.allItems) { return; }

        const bindForElement = (el, point) => {
            if (!el || el.__legendHoverTooltipBound) { return; }
            el.__legendHoverTooltipBound = true;

            Highcharts.addEvent(el, 'mouseover', function () {
                if (point && point.visible === false) { return; }
                if (point && typeof point.setState === 'function') { point.setState('hover'); }
                if (chart.tooltip && typeof chart.tooltip.refresh === 'function') {
                    chart.tooltip.refresh(point);
                } else if (point && typeof point.onMouseOver === 'function') {
                    point.onMouseOver();
                }
            });

            Highcharts.addEvent(el, 'mouseout', function () {
                if (point && typeof point.setState === 'function') { point.setState(); }
                if (chart.tooltip && typeof chart.tooltip.hide === 'function') {
                    chart.tooltip.hide(0);
                } else if (point && typeof point.onMouseOut === 'function') {
                    point.onMouseOut();
                }
            });
        };

        chart.legend.allItems.forEach(item => {
            const isPiePoint = item && item.series && item.series.type === 'pie' && typeof item.y !== 'undefined';
            if (!isPiePoint) { return; }

            const textEl = item.legendItem && item.legendItem.element;
            const symbolEl = item.legendSymbol && item.legendSymbol.element;

            bindForElement(textEl, item);
            bindForElement(symbolEl, item);
        });
    }

    Highcharts.addEvent(Highcharts.Chart, 'load', function () { bindPieLegendHover(this); });
    Highcharts.addEvent(Highcharts.Chart, 'redraw', function () { bindPieLegendHover(this); });

    Highcharts.setOptions({
        lang: {
            decimalPoint: '.',
            thousandsSep: ',',
            noData: 'There is not enough data available for selected parameters. Please choose a different filter option.'
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        colors: [
            '#99D17B',
            '#337357',
            '#00A6A6',
            '#7AE0F9',
            '#2B4570',
            '#EFCA08'
        ],
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: false
                },
                showInLegend: true,
                states: {
                    hover: {
                        halo: {
                            size: 0
                        }
                    }
                },
                borderWidth: 0
            },
        },
        legend: {
            symbolRadius: 2,
            itemStyle: {
                fontFamily: 'Roboto, sans-serif',
                fontSize: '12px',
                color: '#2E292A',
                fontWeight: 400
            }
        },
        chart: {
            fontFamily: 'Roboto, sans-serif',
            fontSize: '14px',
            color: '#2E292A'
        },
        yAxis: {
            lineColor: '#666666',
            gridLineColor: '#666666',
            title: {
                style: {
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: '12px',
                    color: '#2E292A'
                }
            },
            labels: {
                style: {
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: '12px',
                    color: '#2E292A'
                }
            }
        },
        xAxis: {
            lineColor: '#666666',
            gridLineColor: '#666666',
            title: {
                style: {
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: '12px',
                    color: '#2E292A'
                }
            },
            labels: {
                style: {
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: '12px',
                    color: '#2E292A'
                }
            }
        },
        noData: {
            useHTML: true,
            position: {
                align: 'center',
                verticalAlign: 'middle'
            },
            style: {
                fontFamily: 'Roboto, sans-serif',
                fontSize: '14px',
                color: '#423C3D',
                fontWeight: '400'
            }
        }
    });
}